<template>
  <b-modal
    id="waiveFeeModal"
    :visible="show"
    centered
    @hide="$emit('onCloseModal')"
    no-close-on-backdrop
   no-close-on-esc
  >
    <template #modal-header>
      <h5 class="modal-title">
        {{
          type === "group" && row?.waive_status == 1
            ? "Add Enrollment Fee"
            : "Waive Fee"
        }}
      </h5>
      <button type="button" class="close" @click="$emit('onCloseModal')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>

    <div>
      <h6>
        {{
          row && row.waive_status == 1
            ? "Are you sure you want to add enrollment fee ?"
            : "Are you sure you want to waive enrollment fee ?"
        }}
      </h6>
    </div>

    <div class="mb-3">
      <label for="" class="mb-2"
        >Reason<span class="required ms-1"></span> </label
      ><br />
      <textarea
        name=""
        id=""
        rows="5"
        width="100%"
        class="waive-field"
        v-model="reason"
      ></textarea>
    </div>
    <div class="d-flex justify-content-end align-items-center gap-2">
      <button
        class="btn univ-btn sendBtn mb-0 mt-0 w-auto ps-4 pe-4"
        @click="handleWaive"
      >
        Yes
      </button>
      <button class="btn cancel-btn btn-secondary" @click="handleClose">
        Close
      </button>
    </div>
  </b-modal>
</template>

<script>
import Api from "@/resource/Api";
export default {
  name: "WaiveEfeeModal",
  props: {
    show: { type: Boolean, default: false },
    type: { type: String, default: "group" },
    row: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      reason: "",
    };
  },
  methods: {
    handleWaive() {
      if (!this.reason) {
        this.$notify("Please enter reason", "error");
        return;
      }
      if (this.type === "group") {
        this.handleWaiveGroup();
      } else {
        this.handleWaiveMember();
      }
    },
    async handleWaiveGroup() {
      let loader = this.$loading.show();
      const url = "v2/update-waive-fee";
      let success = false;
      try {
        const res = await Api.post(url, {
          reason: this.reason,
          gid: this.row.group_id,
          fee_flag: this.row.waive_status == "1" ? 0 : 1,
        });
        this.$notify(res?.data?.message, "success");
        success = true;
      } catch (err) {
        this.$notify(
          err?.response?.data?.message || "something went wrong",
          "error"
        );
      } finally {
        loader.hide();
        this.reason="";
        if (success) {
          this.$emit("onSuccess");
        }
        this.$emit("onCloseModal");
      }
    },

    async handleWaiveMember() {
      let loader = this.$loading.show();
      const url = "v2/waive-efee-member";
      let success = false;
      try {
        const res = await Api.post(url, {
          reason: this.reason,
          policy_id: this.row.policy_id,
          wave_flag: 1, //typo in wave so make it waive in api
        });
        this.$notify(res?.data?.message, "success");
        success = true;
      } catch (err) {
        this.$notify(
          err?.response?.data?.message || "something went wrong",
          "error"
        );
      } finally {
        loader.hide();
        this.reason="";
        if (success) {
          this.$emit("onSuccess");
        }
        this.$emit("onCloseModal");
      }
    },
    handleClose() {
      this.reason = "";
      this.$emit("onCloseModal");
    },
  },
};
</script>
<style>
.waive-field {
  width: 100%;
  border: 1px solid #dce1e7;
  outline: none;
  border-radius: 6px;
  padding: 9px 15px;
  font-size: 14px;
  transition: all ease 0.6s;
}
#waiveFeeModal .modal-footer {
  display: none;
}
#waiveFeeModal .univ-btn {
  max-width: 100%;
}
.btn {
  min-height: 44px;
  max-height: 44px;
}
.required {
  color: red;
}
</style>
